import React from 'react';

import {useSearchParams} from 'react-router-dom';

import {Grid, Stack, Box, Tabs, Tab, Typography} from '@mui/material';

import UsersTab from './admin/users/UsersTab';
import DashboardTab from '../home/tabs/DashboardTab';
import PageContents from 'components/PageContents';
import CardsTab from '../home/tabs/CardsTab';
import CardOrdersTab from './admin/orders/CardOrders';
import MessagesTabPro from './admin/messages/MessagesTabPro';
import session_ from '../api/session';
import PaymentsTab from './admin/payments/PaymentsTab';
import ProductsTab from './admin/products/ProductsTab';

interface Props {
    tab?: string;
}

export default function DashboardPage(props: Props) {
    //const [params] = useSearchParams();

    //let startTab = params.get("tab") ?? "dashboard";
    //console.log(startTab)

    const [selectedTab, setSelectedTab] = React.useState(props.tab ?? 'dashboard');

    const onTabChange = React.useCallback((evt, value) => {
        setSelectedTab(value);
    }, []);

    if (!session_.isLoggedIn) {
        return (
            <PageContents title='EvoCard - Admin' current='admin' type='data'>
                <Typography sx={{fontSize: '2rem'}}>Secured area: Not logged in</Typography>
            </PageContents>
        );
    }

    return (
        <PageContents title='EvoCard - Admin' current='admin' type='data'>
            <Stack
                direction='row'
                sx={{
                    height: '100%',
                }}
            >
                <Tabs
                    value={selectedTab}
                    onChange={onTabChange}
                    orientation='vertical'
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        minWidth: 200,
                    }}
                >
                    <Tab value='dashboard' label='Dashboard' />
                    <Tab value='users' label='Users' />
                    <Tab value='cards' label='Cards' />
                    <Tab value='orders' label='Orders' />
                    <Tab value='messages' label='Messages' />
                    <Tab value='payments' label='Payments' />
                    <Tab value='products' label='Products' />
                </Tabs>
                <Box
                    sx={{
                        width: '100%',
                        //height: '100%',
                        //mb: 4,
                        p: 2,
                    }}
                >
                    {selectedTab === 'dashboard' && <DashboardTab />}
                    {selectedTab === 'users' && <UsersTab />}
                    {/* {selectedTab === 'pendingUsers' && <PendingUsersTab/>} */}
                    {selectedTab === 'cards' && <CardsTab />}
                    {selectedTab === 'orders' && <CardOrdersTab />}
                    {selectedTab === 'messages' && <MessagesTabPro />}
                    {selectedTab === 'payments' && <PaymentsTab />}
                    {selectedTab === 'products' && <ProductsTab />}
                </Box>
            </Stack>
        </PageContents>
    );
}
